import React, {Component} from 'react';

import {dt, getCode} from 'l10n';

export default function RegionSelect(props) {
    let localeCode = getCode();

    let {name, onChange, value, defaultValue, regions} = props;

    return (
        <select name={name} onChange={onChange} defaultValue={defaultValue}>
            <option value="">{dt('location_select', 'Any')}</option>
            {regions && regions.length && regions.map((region) => <option value={region.code} key={region.code}>{region[localeCode]}</option>)}
        </select>
    )
}


// WEBPACK FOOTER //
// ./src/components/common/RegionSelect.js